<template>
  <tr :style="'background-color:' + line.statusLine" v-if="line.status === 'O'">
    <td class="col-md-1">
      {{ indexLine + 1 }}
    </td>
    <td class="col-md-4">
      <validation-provider
        v-slot="v"
        :name="`${productId}name`"
        rules="required"
      >
        <input
          type="text"
          class="form-control-lg width-max-name"
          :class="{
            'is-invalid': v.errors.length,
          }"
          style="font-size: x-small"
          :value="
            lang === 'pl' ? line.product.name : line.product.descriptionEn
          "
          @input="sendChangeNameEvent"
        />
      </validation-provider>
      <!-- <br />
      {{ $t("products.itemCode") }}: {{ line.product.sku }}
      <div class="input-group-prepend" style="">
        <div class="input-group-text">
          <input
            id="checkbox"
            :readonly="true"
            :value="line.sample === 'Y' ? 'Y' : 'N'"
            :checked="line.sample === 'Y' ? true : false"
            type="checkbox"
            @input="sendChangeSample"
          />
        </div>
        <input
          type="text"
          class="form-control-sm"
          disabled
          :placeholder="$t('common.sample')"
          :aria-label="$t('common.sample')"
          aria-describedby="basic-addon1"
        />
      </div> -->
    </td>
    <td class="col-md-1 text-left width-mid">
      {{ currencyDisplay(line.basePrice) }}
      <!-- <div class="showCustomPriceEdit visible">
        <div class="input-group" style="width: 10em">
          <validation-provider
            v-slot="v"
            :name="`${productId}price`"
            rules="required|between:0,100000"
            slim
          >
            <input
              class="form-control"
              :disabled="!enableCustomPrice"
              :class="{
                'is-invalid': v.errors.length,
              }"
              :value="priceInputValue"
              @input="sendChangePrice"
            />
          </validation-provider>
        </div> -->
      <!-- <span class="badge badge-pill badge-warning float-right mb-3 mt-2">
          {{ currencyDisplay(line.product.lastPrice) }}
        </span> -->
      <!-- </div> -->
      <!-- <br /> -->
    </td>
    <td colspan="2" class="col-md-1">
      <div class="input-group">
        <validation-provider
          v-slot="v"
          :name="`${productId}quantity`"
          :rules="getLineLimitQuantity(line)"
          slim
        >
          <input
            type="text"
            class="form-control width-mid"
            :class="{
              'is-invalid': v.errors.length,
            }"
            :value="quantityInputValue"
            @blur="equalizeQuantity"
            @input="sendChangeQuantityEvent($event.target.value)"
          />
          <div
            v-if="v.failedRules.between && line.product.stock === '0'"
            class="invalid-feedback"
          >
            {{
              $t("basket.errors.quantityLimit", {
                limit: Number(line.product.url),
              })
            }}
          </div>
        </validation-provider>
      </div>
    </td>
    <td
      :class="[
        'badge-pill',
        'float-left',
        'mt-3',
        'fullwidth-span',
        line.product.stockAvailability > 0 ? 'badge-success' : 'badge-danger',
      ]"
    >
      <!-- {{ line.product.stockAvailability }} -->
    </td>
    <td v-show="showExtraField" class="col-md-1 text-right">
      <div class="input-group">
        <validation-provider
          v-slot="v"
          :name="`${productId}quantityToBlocked`"
          :rules="getBlockedQuantityByBlocked(line)"
          slim
        >
          <input
            type="text"
            class="form-control width-mid"
            :class="{
              'is-invalid': v.errors.length,
            }"
            :value="quantityInputBlocked"
            @blur="equalizeQuantityToBlocked"
            @input="sendChangeBlockedQuantityEvent($event.target.value)"
          />
        </validation-provider>
      </div>
    </td>

    <td v-show="showExtraField" colspan="2" class="col-md-1">
      <div class="input-group-sm float-right">
        <validation-provider
          v-slot="v"
          :name="`${productId}quantityToTransport`"
          :rules="getBlockedQuantityByAvailable(line)"
          slim
        >
          <input
            type="text"
            class="form-control width-mid"
            :class="{
              'is-invalid': v.errors.length,
            }"
            :value="quantityInputValueToTransport"
            @blur="equalizeQuantityToTransport"
            @input="sendChangeQuantityToTransportEvent($event.target.value)"
          />
        </validation-provider>
      </div>
      <small
        v-show="line.edit"
        style="background-color: #1a1d2c; padding: 5px; color: white"
        class="float-left"
      >
        {{ line.quantitySended }}
      </small>
    </td>
    <td
      v-show="showExtraField"
      style="font-size:12px!important"
      class="col-md-1"
    >
      <small
        style="background-color: #1a1d2c; padding: 5px; color: white"
        class="float-left form-control-sm"
      >
        {{ $t("products.etollDateFrom") }}
      </small>
      <div class="input-group-sm float-left">
        <validation-provider
          v-slot="v"
          :name="`${productId}etollDateFrom`"
          slim
        >
          <input
            type="date"
            class="form-control-sm width-mid"
            style="font-size:11px!important;"
            :class="{
              'is-invalid': v.errors.length,
            }"
            :value="etollDateFrom"
            @blur="qualizeEtollDateFrom"
            @input="sendChangeEtoolsDateFrom($event.target.value)"
          />
        </validation-provider>
      </div>
      <!-- <small
        v-show="line.edit"
        style="background-color: #1a1d2c; padding: 5px; color: white"
        class="float-left"
      >
        {{ line.quantitySended }}
      </small> -->
    </td>
    <td
      v-show="showExtraField"
      style="font-size:12px!important"
      colspan="2"
      class="col-md-1"
    >
      <small
        style="background-color: #1a1d2c; padding: 5px; color: white"
        class="float-left form-control-sm"
      >
        {{ $t("products.etollEmai") }}
      </small>
      <div class="input-group-sm float-left">
        <validation-provider v-slot="v" :name="`${productId}etollEmai`" slim>
          <input
            type="text"
            class="form-control width-mid"
            style="font-size:11px!important;"
            :class="{
              'is-invalid': v.errors.length,
            }"
            :value="etollEmai"
            @blur="equalizeEtollEmai"
            @input="sendChangeEtoolsEmai($event.target.value)"
          />
        </validation-provider>
      </div>
      <!-- <small
        v-show="line.edit"
        style="background-color: #1a1d2c; padding: 5px; color: white"
        class="float-left"
      >
        {{ line.quantitySended }}
      </small> -->
    </td>
    <td class="col-md-1 text-right">
      {{
        currencyDisplay(line.product.price * getLineFinalQuantity(line), false)
      }}
    </td>
    <td v-show="showDeleteButton" class="text-center">
      <button class="btn btn-sm btn-danger" @click="sendRemoveEvent">
        {{ $t("buttons.delete") }}
      </button>
    </td>
    <!-- || parseInt(line.quantitySended) == 0" -->
  </tr>
</template>
<style scoped>
.width-mid {
  width: 100px;
}
.width-max-name {
  width: 100%;
}
</style>
<script>
import { ValidationProvider } from "vee-validate";
import { currencyMixin } from "../mixins";
import i18n from "../translations";
import { ETollList } from "../enums/ServicesProductsEToll";

export default {
  name: "ShoppingCartLine",
  components: { ValidationProvider },
  mixins: [currencyMixin],
  props: ["line", "indexLine"],
  data: function() {
    return {
      showEtollSku: false,
      eTollsList: ETollList,
      enableCustomPrice: this.line.product.sku === "U_TRS" ? true : false,
      priceInputValue: this.line.product.price,
      quantityInputValue: this.line.quantity,
      quantityInputValueToTransport: this.line.quantityToTransport,
      etollDateFrom: this.line.etollDateFrom,
      etollEmai: this.line.etollEmai,
      quantityInputBlocked: this.line.quantityToBlocked,
      quantityAvailable: this.line.product.stockAvailability,
      quantityInputEqualizerTimeout: null,
      quantityInputValueToTransportEqualizerTimeout: null,
      quantityBlockedEqualizerTimeout: null,
      showDeleteButton: parseInt(this.line.quantitySended) > 0 ? false : true,
      sample: this.line.sample,
    };
  },
  computed: {
    lang() {
      return i18n.locale;
    },
    productId() {
      return this.line.product.id;
    },
    enableDiscount() {
      return !this.enableCustomPrice;
    },
    showExtraField() {
      return false;
    },
  },
  watch: {
    "line.product.price": function() {
      this.priceInputValue = this.line.product.price;
    },
    quantityInputValue: function(newValue, oldValue) {
      if (this.quantityInputEqualizerTimeout) {
        clearTimeout(this.quantityInputEqualizerTimeout);
      }
      this.quantityInputEqualizerTimeout = setTimeout(
        this.equalizeQuantity,
        2000
      );
    },
    quantityInputValueToTransport: function(newValue, oldValue) {
      if (this.quantityInputValueToTransportEqualizerTimeout) {
        clearTimeout(this.quantityInputValueToTransportEqualizerTimeout);
      }
      this.quantityInputValueToTransportEqualizerTimeout = setTimeout(
        this.equalizeQuantityToTransport,
        2000
      );
    },
    quantityInputBlocked: function(newValue, oldValue) {
      if (this.quantityBlockedEqualizerTimeout) {
        clearTimeout(this.quantityBlockedEqualizerTimeout);
      }
      this.quantityBlockedEqualizerTimeout = setTimeout(
        this.equalizeQuantityToBlocked,
        2000
      );
    },
  },
  methods: {
    displayFieldsEtolls(sku) {
      const country = this._data.eTollsList.find(function(element) {
        return element.sku == sku ? true : false;
      });
      return country == null ? false : true;
    },
    parseDate(date) {
      return new Date(date).toISOString().substr(0, 10);
    },
    getLineLimitQuantity(line) {
      // debugger;
      // let minQty = 0;
      // if(line.edit){
      // //   minQty = (line.product.url != "")? line.product.url : "0";
      // }
      // <h2 v-else-if="order.status === 'edit'">{{ $t("buttons.editOrder") }}</h2>
      // return `numeric|required|positive|between:${minQty},10000000`;
      //return `numeric|required|positive|between:0,10000000`;
      return `numeric|required|positive|between:0,${
        line.product.stock === "0" ? "10000000" : line.product.stockAvailability
      }`;
    },
    getLineFinalQuantity(line) {
      return Math.ceil(line.quantity);
    },
    getLineFinalQuantityToBlocked(line) {
      return Math.ceil(line.quantityToBlocked);
    },
    getLineFinalETollIMEI(line) {
      return line.etollEmai;
    },
    getLineFinalETollDateFrom(line) {
      return line.etollDateFrom;
    },
    getLineFinalQuantityToTransport(line) {
      return Math.ceil(line.quantityToTransport);
    },
    getBlockedQuantityByAvailable(line) {
      let maxQtyToSend = parseInt(this.line.quantity);
      let max =
        this.quantityInputBlocked < parseInt(line.product.stockAvailability)
          ? this.quantityInputBlocked
          : maxQtyToSend;
      return `numeric|required|between:0,${max}`;
    },
    getMinAndMaxPrice(line) {
      debugger;
      let min = 0;
      let lastPrice = parseFloat(line.product.lastPrice);
      let plnPrice = parseFloat(line.product.priceAfterDiscount);
      if (lastPrice > 0) {
        min = parseFloat(line.product.lastPrice);
      } else if (lastPrice == 0) {
        min = parseFloat(line.product.priceAfterDiscount);
      }
      if (plnPrice < lastPrice && lastPrice !== 0) {
        min = plnPrice;
      }
      return `required|between:${min},100000`;
      //return `required|between:5.95,100000`;
    },
    getBlockedQuantityByBlocked(line) {
      let max = line.product.stockAvailability;
      max =
        parseInt(line.product.stockAvailability) == "0"
          ? "99999"
          : line.product.stockAvailability;

      return `numeric|required`;
      // return `numeric|required|between:-10000,${max}`;
      //return `numeric|required|positive|between:0,${line.product.stockOpen}`;
    },
    sendChangePrice($event) {
      if (!isNaN($event.target.value))
        this.$emit("price", Number($event.target.value));

      this.priceInputValue = $event.target.value;
    },
    equalizeQuantity() {
      this.sendChangeQuantityEvent(this.getLineFinalQuantity(this.line));
    },
    equalizeQuantityToTransport() {
      this.sendChangeQuantityToTransportEvent(
        this.getLineFinalQuantityToTransport(this.line)
      );
    },
    equalizeQuantityToBlocked() {
      this.sendChangeBlockedQuantityEvent(
        this.getLineFinalQuantityToBlocked(this.line)
      );
    },
    equalizeEtollEmai() {
      this.sendChangeEtoolsEmai(this.getLineFinalETollIMEI(this.line));
    },
    qualizeEtollDateFrom() {
      this.sendChangeEtoolsDateFrom(this.getLineFinalETollDateFrom(this.line));
    },
    sendChangeQuantityEvent(value) {
      if (!isNaN(value)) this.$emit("quantity", Number(value));

      this.quantityInputValue = value;
    },
    sendChangeQuantityToTransportEvent(value) {
      if (!isNaN(value)) this.$emit("quantityToTransport", Number(value));
      this.quantityInputValueToTransport = value;
    },
    sendChangeEtoolsEmai(value) {
      if (!isNaN(value)) this.$emit("etollsEmai", Number(value));
      this.etollEmai = value;
    },
    sendChangeEtoolsDateFrom(value) {
      if (value && Date.parse(value) !== NaN) {
        this.$emit("etollsDateFrom", value);
      }
      this.etollDateFrom = value;
      // if (!isNaN(value)) this.$emit("etollsDateFrom", Number(value));
      // this.etollDateFrom = value;
    },
    sendChangeBlockedQuantityEvent(value) {
      if (!isNaN(value)) this.$emit("quantityToBlocked", Number(value));
      this.quantityInputBlocked = value;
    },
    sendChangeSample(value) {
      let sampleValue = value.target.checked;
      if (sampleValue) {
        this.$emit("sample", "Y");
        this.sample = "Y";
      } else {
        this.$emit("sample", "N");
        this.sample = "N";
      }
    },
    sendChangeNameEvent($event) {
      this.$emit("description", {
        value: $event.target.value,
        lang: this.lang,
      });
    },
    sendRemoveEvent() {
      if (this.line.edit == true) {
        this.$emit("statusLine", this.line);
      } else {
        this.$emit("remove", this.line);
      }
    },
  },
};
</script>
